export default "__VITE_ASSET__BzDv1O_4__"